var _g, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Opcje_-_ikona",
    "data-name": "Opcje - ikona",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Opc"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3661",
    "data-name": "Path 3661",
    d: "M296.5,47.071V43.929h-1.713a9.342,9.342,0,0,0-.458-1.712l1.482-.856-1.571-2.722-1.475.852a9.484,9.484,0,0,0-1.256-1.256l.852-1.475-2.722-1.571-.856,1.482a9.34,9.34,0,0,0-1.712-.458V34.5h-3.143v1.713a9.341,9.341,0,0,0-1.712.458l-.856-1.482-2.722,1.571.852,1.475a9.484,9.484,0,0,0-1.256,1.256l-1.475-.852-1.571,2.722,1.482.856a9.345,9.345,0,0,0-.458,1.712H274.5v3.143h1.713a9.345,9.345,0,0,0,.458,1.712l-1.482.856,1.571,2.722,1.475-.852a9.485,9.485,0,0,0,1.256,1.256l-.852,1.475,2.722,1.571.856-1.482a9.341,9.341,0,0,0,1.712.458V56.5h3.143V54.787a9.341,9.341,0,0,0,1.712-.458l.856,1.482,2.722-1.571-.852-1.475a9.485,9.485,0,0,0,1.256-1.256l1.475.852,1.571-2.722-1.482-.856a9.342,9.342,0,0,0,.458-1.712ZM291.786,45.5a6.286,6.286,0,1,1-6.286-6.286A6.285,6.285,0,0,1,291.786,45.5Z",
    transform: "translate(-274.5 -34.5)",
    fill: "#464af0"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_69",
    "data-name": "Ellipse 69",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(8 8)",
    fill: "#464af0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.107f2dc85b3c53bb7dc84d54732c705b.svg";
export { ForwardRef as ReactComponent };